<template>
  <div :class="{ big_wrap: showWriteAddress == true || showDateMask == true }">
    <top-header-info></top-header-info>
    <top-logo state="3"></top-logo>
    <!-- <right-nav></right-nav> -->
    <div class="check_order_wrap w">
      <div class="check_order">
        <div class="title">
          <h2>填写并核对订单信息</h2>
        </div>
        <div class="address_wrap">
          <h3>收货人信息</h3>
          <address-list
            @showMask="showMask"
            :checkAddress="checkAddress"
          ></address-list>
        </div>
        <div class="pay_method_wrap">
          <h3>支付方式</h3>
          <div class="pay_method">
            <div
              v-for="(item, index) in payMethods"
              :key="index"
              @click="checkPayment = item.code"
              :style="{
                backgroundImage:
                  checkPayment == item.code ? `url(${payBg})` : '',
                color: checkPayment == item.code ? '#FD6C17' : ''
              }"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="order-list">
          <el-row>
            <el-col :span="12">
              <h2>商品清单</h2>
            </el-col>
            <el-col :span="12">
              <!-- <router-link :to="{ name: 'shopping-cart' }"
                >&lt;&lt; 返回购物车修改</router-link
              > -->
              <!-- <el-button
                round
                v-if="removeBtnActive && !all_ready"
                class="remove-btn"
                @click="delGoods"
                >删除异常商品</el-button
              > -->
            </el-col>
          </el-row>
          <div
            class="product_type_wrap"
            v-for="(item, index) in orderInfo"
            :key="index"
          >
            <div class="products_type_tit">{{ item.name }}</div>
            <table class="product-table" cellspacing="0">
              <thead>
                <tr
                  class="product_tit"
                  style="background-color: #fff; height: 24px"
                >
                  <th></th>
                  <th>单价</th>
                  <th>数量</th>
                  <th>小计</th>
                  <th style="color: #333">合计</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="goods-item"
                  v-for="(i, index) in item.items"
                  :key="i.product_id"
                >
                  <td class="td-product">
                    <div class="product">
                      <img
                        :src="i.image || defaultGoods"
                        alt="goods"
                        align="center"
                      />
                      <div>
                        <div>
                          {{ i.name }}
                        </div>
                        <div class="type">
                          {{ i.option_values }}
                        </div>
                        <div class="sku">SKU：{{ i.sku }}</div>
                      </div>
                      <p v-if="i.not_match_rule === 1">
                        <span class="red_word">【禁售】</span>
                      </p>
                      <p v-else>
                        <span v-if="!i.can_buy_status" class="red_word"
                          >【{{ i.can_buy_status_text }}】</span
                        >
                      </p>
                    </div>
                    <div class="groups" v-if="i.group.length > 0">
                      <div
                        class="group"
                        v-for="group in i.group"
                        :key="group.id"
                      >
                        <img
                          :src="group.product.thumbnail || defaultGoods"
                          alt
                        />
                        <div class="name">{{ group.product.name }}</div>
                        <div class="num">
                          X {{ group.quantity * i.quantity }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="modeOfDistribution"
                      v-if="i.calendarType == 'normal'"
                    >
                      <div class="way">
                        <span>配送方式</span><span>默认快递</span>
                      </div>
                    </div>
                    <div class="modeOfDistribution" v-if="i.time">
                      <div v-if="i.merge_status == 1" style="display: flex">
                        <div class="way">
                          <span>配送方式</span><span>京东快递</span>
                        </div>
                        <div class="time">
                          <span v-if="i.calendarType == 'calendar'">
                            <span v-if="!isMerge"
                              >工作日、双休日与假日均可送货</span
                            >
                            <span v-else>
                              合并送货
                              {{ jd_promise_calendar.promise_date }}
                              <i style="color: #e64a3e"
                                >[{{ jd_promise_calendar.promise_week }}]</i
                              >
                              {{ jd_promise_calendar.promise_time_range }}
                            </span>
                          </span>
                          <span v-else-if="i.calendarType == 'la_calendar'">
                            预计 {{ jd_promise_calendar.reserving_date }}
                            <i>[{{ jd_promise_calendar.reserving_week }}]</i>
                            送达
                          </span>
                          <span
                            @click="editTime(i.time, i.calendarType)"
                            v-if="isMerge"
                            class="editTime"
                            >修改</span
                          >
                          <span>
                            <el-checkbox v-model="isMerge"
                              >中小件合并发货</el-checkbox
                            >
                            <el-popover
                              placement="bottom"
                              width="200"
                              trigger="click"
                              content="
                              您购买的商品分属不同仓库，可能会分多次上门配送。选择合并送货后配送员将等待所有商品配齐后一次上门配送。
                            "
                            >
                              <b
                                class="el-icon el-icon-hint"
                                slot="reference"
                                click
                              ></b>
                            </el-popover>
                          </span>
                        </div>
                      </div>
                      <div v-else style="display: flex">
                        <div class="way">
                          <span>配送方式</span><span>京东快递</span>
                        </div>
                        <div class="time">
                          <span>标准达：</span>
                          <span v-if="i.calendarType == 'calendar'">
                            预计 {{ jd_promise_calendar.promise_date }}
                            <i style="color: #e64a3e"
                              >[{{ jd_promise_calendar.promise_week }}]</i
                            >
                            {{ jd_promise_calendar.promise_time_range }}
                            送达
                          </span>
                          <span v-else-if="i.calendarType == 'la_calendar'">
                            预计 {{ jd_promise_calendar.reserving_date }}
                            <i>[{{ jd_promise_calendar.reserving_week }}]</i>
                            送达
                          </span>
                          <span
                            @click="editTime(i.time, i.calendarType)"
                            class="editTime"
                            >修改</span
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="td-price">{{ setFormat(i.special) }}</td>
                  <!-- <td v-if="i.stock!=1" class="td-count">{{i.quantity=0}}</td> -->
                  <td class="td-count">{{ i.quantity }}</td>
                  <!-- <td v-if="i.stock!=1" class="td-total red_word">{{i.total=0 | jifen}}</td> -->
                  <td class="td-total red_word">
                    {{ setFormat(i.total) | jifen }}
                  </td>
                  <td
                    v-if="index == 0"
                    :rowspan="item.items.length + 1"
                    class="totalforcat red_word"
                  >
                    {{ item.total | jifen }}
                  </td>
                </tr>
                <tr class="td-footer">
                  <!-- <td colspan="2" v-if="item.code == 'bestcake'">
                    配送时间：{{ deleverDate }}{{ deleverDate | dayFormat }}
                    {{ deleverTime }}
                    <el-button class="change-time" @click="showDateMask = true"
                      >更改配送时间</el-button
                    >
                  </td>
                  <td colspan="2" v-else></td> -->
                  <td colspan="2"></td>
                  <td colspan="2">
                    运费：
                    <!-- <span>普通配送快递</span> -->
                    <b class="red_word" v-if="item.shipping == 0 && isCheckOut"
                      >免运费</b
                    >
                    <b class="red_word" v-else-if="!isCheckOut"
                      >选择收货地址后显示邮费</b
                    >
                    <b class="red_word" v-else>{{ item.shipping | jifen }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="remark">
          <div>订单备注</div>
          <p>
            <textarea v-model="comment"></textarea>
          </p>
        </div>
        <div class="order-footer-info">
          <div v-for="(item,index) in total" :key="index">
            {{item.title}}：
            <span :class="{red_word:index=='total'}">{{item.value | jifen}}</span>
          </div>
        </div>-->
      </div>

      <div class="real_pay_wrap">
        <p @click="getCoupon">
          优惠券：
          <span v-if="a_coupon.length === 0" class="a-button"
            >无可用优惠券<i class="el-icon el-icon-arrow-right"></i
          ></span>
          <span class="a-button red" v-else>
            <span v-if="couponId === -1">{{ coupon_text }}</span>
            <span v-else>{{ coupon_text | jifen }}</span>
            <i class="el-icon el-icon-arrow-right"></i>
          </span>
        </p>
        <p v-if="total.credit && total.credit.value">
          账户余额：
          <span class="red_word">
            {{ total.credit && total.credit.value | jifen }}
          </span>
        </p>
        <p>
          应付总额：
          <span class="red_word">
            {{ total.total && total.total.value | jifen }}
          </span>
        </p>
        <p style="word-break: break-all">
          寄送至：{{ getAddress }}
          {{ checkAddress.address }}
        </p>
        <p style="color: #fc0010" v-if="all_ready">
          商品清单中全为异常商品请返回购物车后修改提交
        </p>
        <p style="color: #fc0010" v-else-if="removeBtnActive">
          商品清单中存在异常商品，请删除异常商品或或返回购物车后修改提交
        </p>

        <p v-if="removeBtnActive">
          <router-link :to="{ name: 'shopping-cart' }"
            >&lt;&lt; 返回购物车修改</router-link
          >
          <el-button
            round
            v-if="removeBtnActive && !all_ready"
            class="remove-goods"
            @click="delGoods"
            >删除异常商品</el-button
          >
        </p>
        <p v-else>
          <router-link
            v-show="!canCheckOut || checkAddress.id == ''"
            :to="{ name: 'shopping-cart' }"
            >&lt;&lt; 返回购物车修改</router-link
          >
          <el-button
            @click="checkOut"
            :class="{ 'btn-disabled': !canCheckOut || checkAddress.id == '' }"
            :disabled="!canCheckOut || checkAddress.id == ''"
            :loading="submitBtnStatus"
            >提交订单</el-button
          >
        </p>
      </div>
      <!-- mask -->
      <!-- <div class="mask_wrap" v-if="showDateMask">
        <div>
          <el-row class="mask_title">
            <el-col :span="23">配送时间</el-col>
            <el-col :span="1">
              <i
                class="el-icon-close"
                @click="
                  showDateMask = false;
                  resetTempTime();
                "
              ></i>
            </el-col>
          </el-row>
          <el-row class="mask_info">
            <el-col :span="10" class="date-list">
              <li
                :class="{ actived: tempDeleverDate == item }"
                @click="tempDeleverDate = item"
                v-for="(item, index) in dates"
                :key="index"
              >
                {{ item }} {{ item | dayFormat }}
              </li>
            </el-col>
            <el-col :span="12" class="time-list">
              <li
                :class="{ actived: tempDeleverTime == item }"
                @click="tempDeleverTime = item"
                v-for="(item, index) in times"
                :key="index"
              >
                {{ item }}
              </li>
            </el-col>
          </el-row>
          <el-row class="mask_button">
            <el-col :span="12">
              <el-button
                @click="
                  showDateMask = false;
                  deleverDate = tempDeleverDate;
                  deleverTime = tempDeleverTime;
                "
                >确 定</el-button
              >
            </el-col>
            <el-col :span="12">
              <el-button
                @click="
                  showDateMask = false;
                  resetTempTime();
                "
                >取 消</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div> -->
      <!--修改配送时间模态框 -->
      <el-dialog :visible.sync="showEditDateModel" class="editDeliveryTimeBox">
        <span slot="title">配送</span>
        <div class="way">京东快递</div>
        <div class="timeBox" v-if="currentCalendarType == 'calendar'">
          <ul class="calendarDateBox">
            <li
              v-for="item in currentTimeList"
              :key="item.date"
              :class="currentTimeDate.date == item.date ? 'active' : ''"
              @click="currentTimeDate = item"
            >
              <span>
                {{ item.date }}
              </span>
              <span> [{{ item.week }}]</span>
            </li>
          </ul>
          <ul class="calendarTimeBox">
            <li
              v-for="(item, index) in currentTimeDate.time_list"
              :key="index"
              :class="
                currentTimePointDate.time_range == item.time_range
                  ? 'active'
                  : ''
              "
              :style="{
                backgroundImage:
                  currentTimePointDate.time_range == item.time_range
                    ? `url(${payBg})`
                    : ''
              }"
              @click="currentTimePointDate = item"
            >
              {{ item.time_range }}
            </li>
          </ul>
        </div>
        <div class="timeBox" v-else-if="currentCalendarType == 'la_calendar'">
          <ul class="gridBox">
            <li
              v-for="item in currentTimeList"
              :key="item.date"
              :class="currentTimeDate.date == item.date ? 'active' : ''"
              @click="currentTimeDate = item"
              style="display: flex; flex-direction: column"
            >
              <span>
                {{ item.date }}
              </span>
              <span
                :class="
                  item.week == '周六' || item.week == '周日' ? 'weekend' : ''
                "
              >
                [{{ item.week }}]
              </span>
            </li>
          </ul>
        </div>
        <div class="tips">
          温馨提示：期望送达时间为预估时间，仅供参考，具体请以实际送达时间为准。可能会因天气、交通、商家备货、订单先后顺序等各类因素影响造成延误或推迟，大件货物请注意接听配送人员电话预约送货时间。
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              confirmEditDate();
              showEditDateModel = false;
            "
            >确 定</el-button
          >
          <el-button @click="showEditDateModel = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="coupon_show"
        width="800px"
        class="coupon-dialog"
      >
        <div slot="title">
          <el-tabs v-model="activeName">
            <el-tab-pane label="可用优惠券" name="1"></el-tab-pane>
            <el-tab-pane label="不可用优惠券" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <couponList
          :lists="lists"
          :checked="true"
          :activeName="activeName"
          :couponId="couponId"
          @changeCoupon="changeCoupon"
        ></couponList>
        <span slot="footer" class="dialog-footer">
          <div v-if="activeName === '1'">
            <el-button
              type="primary"
              @click="checkoutCoupon"
              class="coupon-confirm"
              >确定</el-button
            >
            <el-button @click="closeCoupon">不使用优惠券</el-button>
          </div>
          <div v-else>
            <el-button
              type="primary"
              @click="coupon_show = false"
              class="coupon-confirm"
              >关闭</el-button
            >
          </div>
        </span>
      </el-dialog>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import moment from "moment";
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import AddressList from "@/components/address-list";
import { MessageBox } from "element-ui";
import PAYCHECKED from "@/assets/images/pay_checked.png";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import couponList from "@/components/coupon-list/index";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    HomeBanner,
    AddressList,
    couponList
  },
  data() {
    return {
      couponId: 0,
      coupon: [],
      a_coupon: [],
      orderInfo: [],
      addressList: [],
      total: "",
      loadingOption: { background: "rgba(0,0,0,0)" },
      payBg: PAYCHECKED,
      payMethods: [{ code: "inline", title: "在线支付" }],
      defaultAddress: "0",
      showWriteAddress: false,
      reviseAddress: "",
      checkPayment: "",
      checkAddress: { id: "" },
      dates: [],
      times: [
        "11:00-12:00",
        "12:00-13:00",
        "13:00-14:00",
        "14:00-15:00",
        "15:00-16:00",
        "16:00-17:00",
        "17:00-18:00"
      ],
      deleverDate: "",
      tempDeleverDate: "",
      deleverTime: "",
      tempDeleverTime: "",
      showDateMask: false,
      comment: "",
      canCheckOut: false,
      userOrderInfo: "",
      isCheckOut: false,
      removeBtnActive: false,
      all_ready: false,
      product_ids: [],
      defaultGoods: DEFAULTGOODS,
      message: sessionStorage.getItem("activityMessage"),
      showEditDateModel: false,
      sku_data: [], //获取送达时间
      jd_promise_calendar: {
        // product_ids: {},
        // nomerge_product_ids: {},
        // promise_date: "",
        // promise_week: "",
        // promise_time_range: "",
        // promise_time_range_code: "",
        // reserving_date: "",
        // reserving_week: "",
        // reserving_date_code: ""
      },
      currentTimeDate: {},
      currentTimePointDate: {},
      currentTimeList: [],
      currentCalendarType: "", //商品大小件类型
      submitBtnStatus: false,
      isMerge: false, //是否选择合并中小件
      coupon_show: false,
      activeName: "1",
      coupon_total: {}
    };
  },
  watch: {
    addressList: {
      handler(val) {
        if (val.length == 0) {
          this.checkAddress.id = "";
        }
      },
      deep: true
    },
    isMerge: {
      handler(val) {
        if (val) {
          this.jd_promise_calendar.promise_date = this.jd_promise_calendar.nomerge_promise_date;
          this.jd_promise_calendar.promise_week = this.jd_promise_calendar.nomerge_promise_week;
          this.jd_promise_calendar.promise_time_range = this.jd_promise_calendar.nomerge_promise_time_range;
          this.jd_promise_calendar.promise_time_range_code = this.jd_promise_calendar.nomerge_promise_time_range_code;
        } else {
          this.jd_promise_calendar.promise_date = "";
          this.jd_promise_calendar.promise_week = "";
          this.jd_promise_calendar.promise_time_range = "";
          this.jd_promise_calendar.promise_time_range_code = "";
        }
      }
    },
    checkAddress() {
      this.validAddress();
    }
  },
  computed: {
    getAddress() {
      if (this.checkAddress) {
        return (
          ((this.checkAddress.zone && this.checkAddress.zone.name) || "") +
          " " +
          ((this.checkAddress.city && this.checkAddress.city.name) || "") +
          " " +
          ((this.checkAddress.area && this.checkAddress.area.name) || "") +
          " " +
          ((this.checkAddress.town && this.checkAddress.town.name) || "")
        );
      }
      return "";
    },
    lists() {
      let list = [];
      if (this.activeName === "1") {
        list = this.coupon.filter(item => item.is_available);
      } else {
        list = this.coupon.filter(item => !item.is_available);
      }
      return list;
    },
    coupon_text() {
      if (this.couponId === -1 || !this.coupon_total.value) {
        return `${this.a_coupon.length}张优惠券可用`;
      }
      return this.coupon_total.value;
    }
  },
  mounted() {
    this.getAddressList();
    this.getBestCakeDate();
  },
  created() {
    this.$bus.$off("change-user-address"); //当这个组件销毁的时候bus也跟着一起销毁
    this.$bus.$off("updateAddressList"); //当这个组件销毁的时候bus也跟着一起销毁
    this.$bus.$off("editAddress"); //当这个组件销毁的时候bus也跟着一起销毁
    this.$bus.on("change-user-address", item => {
      this.checkAddress = item;
      this.isCheckOut = true;
      this.checkAddressHasStock(this.checkAddress);
    });
    this.$bus.on("updateAddressList", () => {
      this.isCheckOut = false;
      this.getAddressList();
    });
    this.$bus.on("editAddress", data => {
      if (data.id === this.checkAddress.id) {
        this.checkAddress = data;
      }
    });
  },
  methods: {
    async getOrderInfo(addressId) {
      if (!addressId) {
        return;
      }
      await this.$reqGet("api/store/checkout", {
        address_id: addressId,
        coupon_id: this.couponId
      }).then(res => {
        let data = res.data.data.products_bucket;
        this.coupon = res.data.data.coupon.map(item => {
          item.start_date = moment(item.coupon_template.start_time).format(
            "YYYY-MM-DD"
          );
          item.end_date = moment(item.coupon_template.end_time).format(
            "YYYY-MM-DD"
          );
          if (this.getDay(item.start_date) > 0) {
            item.text = "未开始";
            item.disabled = true;
          } else {
            item.text = "去使用";
          }
          return item;
        });
        if (this.coupon.length > 0) {
          this.a_coupon = this.coupon.filter(item => item.is_available);
          let list = this.coupon.filter(item => item.selected);
          if (list.length > 0) {
            this.couponId = list[0].id;
          } else {
            this.couponId = -1;
          }
        }
        this.allProductsData = data;
        if (data[2].items && data[2].items.length > 0) {
          this.hasBsk = true;
        }
        this.orderInfo = data.filter(item => {
          return item.items.length > 0;
        });
        this.total = res.data.data.total;
        this.coupon_total = this.total.coupon || {};
        this.canCheckOut = res.data.data.can_checkout;
        if (res.data.data.warning_msg) {
          MessageBox.alert("错误信息：" + res.data.data.warning_msg);
        }
        if (this.payMethods.length > 0) {
          this.checkPayment = this.payMethods[0].code;
        }
        let no_stock = false;
        this.all_ready = false;
        let num = 0;
        let num1 = 0;
        this.sku_data.splice(0, this.sku_data.length);
        for (let i = 0; i < this.orderInfo.length; i++) {
          for (let j = 0; j < this.orderInfo[i].items.length; j++) {
            if (this.orderInfo[i].items[j].not_match_rule === 1) {
              this.orderInfo[i].items[j].can_buy_status = false;
            }
            num++;
            if (
              this.orderInfo[i].items[j].stock == 0 ||
              !this.orderInfo[i].items[j].can_buy_status
            ) {
              no_stock = true;
              num1++;
            }
            if (this.orderInfo[i].code == "jd") {
              this.sku_data.push({
                sku_id: this.orderInfo[i].items[j].sku,
                num: Number(this.orderInfo[i].items[j].quantity)
              });
            }
          }
        }
        if (num == num1) {
          this.all_ready = true;
        }
        this.removeBtnActive = no_stock;
      });
      await this.$reqPost(
        `api/ecomm/product/promise_calendar/${addressId}`,
        {
          sku_data: this.sku_data
        },
        {
          noStringify: true,
          noAlertMessage: true
        }
      )
        .then(res => {
          if (res.data.success) {
            let shopList = [];
            this.isMerge = false;
            this.jd_promise_calendar = {
              product_ids: {},
              nomerge_product_ids: {},
              promise_date: "",
              promise_week: "",
              promise_time_range: "",
              promise_time_range_code: "",
              reserving_date: "",
              reserving_week: "",
              reserving_date_code: ""
            };
            this.orderInfo.forEach(element => {
              if (element.code == "jd") {
                shopList = element.items;
                element.items = [];
                // 处理返回的sku_id有重复的值
                res.data.data.calendar.sku_ids &&
                  (res.data.data.calendar.sku_ids = this.removeDuplicate(
                    res.data.data.calendar.sku_ids
                  ));
                if (
                  res.data.data.calendar.sku_ids &&
                  res.data.data.calendar.sku_ids.length < 2 &&
                  res.data.data.calendar.merge_status == 1
                ) {
                  res.data.data.calendar.merge_status = 0;
                }
                res.data.data.la_calendar.sku_ids &&
                  (res.data.data.la_calendar.sku_ids = this.removeDuplicate(
                    res.data.data.la_calendar.sku_ids
                  ));
                // 返回的sku_id有重复的值
                res.data.data.calendar.sku_ids &&
                  res.data.data.calendar.time &&
                  res.data.data.calendar.sku_ids.forEach((item, index) => {
                    for (let i = 0; i < shopList.length; i++) {
                      if (item == shopList[i].sku) {
                        if (res.data.data.calendar.merge_status == 0) {
                          this.jd_promise_calendar.product_ids[
                            shopList[i].product_id
                          ] = 1;
                        } else {
                          this.jd_promise_calendar.nomerge_product_ids[
                            shopList[i].product_id
                          ] = 1;
                        }
                        if (
                          index ==
                          res.data.data.calendar.sku_ids.length - 1
                        ) {
                          shopList[i].time = res.data.data.calendar.time;
                          shopList[i].calendarType = "calendar";
                          shopList[i].merge_status =
                            res.data.data.calendar.merge_status;
                          if (res.data.data.calendar.merge_status == 0) {
                            this.jd_promise_calendar.promise_date =
                              shopList[i].time[0].date;
                            this.jd_promise_calendar.promise_week =
                              shopList[i].time[0].week;
                            this.jd_promise_calendar.promise_time_range =
                              shopList[i].time[0].time_list[0].time_range;
                            this.jd_promise_calendar.promise_time_range_code =
                              shopList[i].time[0].time_list[0].time_range_code;
                          } else {
                            this.jd_promise_calendar.nomerge_promise_date =
                              shopList[i].time[0].date;
                            this.jd_promise_calendar.nomerge_promise_week =
                              shopList[i].time[0].week;
                            this.jd_promise_calendar.nomerge_promise_time_range =
                              shopList[i].time[0].time_list[0].time_range;
                            this.jd_promise_calendar.nomerge_promise_time_range_code =
                              shopList[i].time[0].time_list[0].time_range_code;
                          }
                        }
                        element.items.push(shopList[i]);
                        shopList.splice(i, 1);
                        return;
                      }
                    }
                  });
                res.data.data.la_calendar.sku_ids &&
                  res.data.data.la_calendar.time &&
                  res.data.data.la_calendar.sku_ids.forEach((item, index) => {
                    for (let i = 0; i < shopList.length; i++) {
                      if (item == shopList[i].sku) {
                        this.jd_promise_calendar.product_ids[
                          shopList[i].product_id
                        ] = 2;
                        if (
                          index ==
                          res.data.data.la_calendar.sku_ids.length - 1
                        ) {
                          shopList[i].time = res.data.data.la_calendar.time;
                          shopList[i].calendarType = "la_calendar";
                          this.jd_promise_calendar.reserving_date =
                            shopList[i].time[0].date;
                          this.jd_promise_calendar.reserving_week =
                            shopList[i].time[0].week;
                          this.jd_promise_calendar.reserving_date_code =
                            shopList[i].time[0].reserving_date;
                        }
                        element.items.push(shopList[i]);
                        shopList.splice(i, 1);
                        return;
                      }
                    }
                  });
                if (shopList.length > 0) {
                  shopList.forEach((item, index) => {
                    if (index == shopList.length - 1) {
                      item.calendarType = "normal";
                    }
                    element.items.push(item);
                  });
                }
              }
            });
          }
        })
        .catch(() => {
          this.orderInfo.forEach(element => {
            if (element.code == "jd" && element.items.length !== 0) {
              this.$set(
                element.items[element.items.length - 1],
                "calendarType",
                "normal"
              );
            }
          });
        });
    },
    //数组去重
    removeDuplicate(arr) {
      return arr.filter((item, index) => {
        return arr.indexOf(item) === index;
      });
    },
    getBestCakeDate() {
      this.$reqGet("api/store/bestcake/deliver_date").then(res => {
        let delieverDate = res.data.data;
        let startDate = delieverDate.start_time;
        this.deleverDate = startDate;
        this.tempDeleverDate = this.deleverDate;
        this.deleverTime = this.times[0];
        this.tempDeleverTime = this.deleverTime;
        let startDate_ms = Date.parse(new Date(startDate.replace(/-/g, "/")));
        let endDate = delieverDate.end_time;
        let endDate_ms = Date.parse(new Date(endDate.replace(/-/g, "/")));
        let days = Math.floor((endDate_ms - startDate_ms) / (24 * 3600 * 1000));
        let next = "";
        for (let i = 0; i <= days; i++) {
          next = this.getWhenDate(startDate_ms, i);
          this.dates.push(next);
        }
      });
    },
    resetTempTime() {
      this.tempDeleverDate = this.deleverDate;
      this.tempDeleverTime = this.deleverTime;
    },
    getWhenDate(start, addNum) {
      var ms, thatDay, y, m, d, endDate;
      ms = start + addNum * 24 * 60 * 60 * 1000;
      thatDay = new Date(ms);
      y = thatDay.getFullYear();
      m = thatDay.getMonth() + 1;
      d = thatDay.getDate();
      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      endDate = y + "-" + m + "-" + d;
      return endDate;
    },
    getAddressList() {
      this.$reqGet("api/store/address").then(res => {
        this.addressList = res.data.data;
        if (this.addressList.length !== 0) {
          this.checkAddress = this.addressList[0];
          this.addressList.map(item => {
            if (item.is_default == 1) {
              this.checkAddress = item;
              this.isCheckOut = true;
              this.checkAddressHasStock(this.checkAddress);
            }
          });
          if (!this.isCheckOut) {
            this.checkAddress = this.addressList[0];
            this.isCheckOut = true;
            this.checkAddressHasStock(this.checkAddress);
          }
        } else {
          this.checkAddress = { id: "" };
        }
      });
    },
    showMask(data) {
      if (!data) {
        this.showWriteAddress = false;
      } else {
        this.showWriteAddress = true;
      }
    },
    checkOut() {
      if (this.checkAddress.valid === 0) {
        this.$alert("收货地址已失效，请重新编辑", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }

      if (this.message) {
        this.$alert(this.message, "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      this.$confirm(
        `
        <div style="color:#E4393D">订单一经提交将不支持修改收货人信息及地址，请您再次确认收货地址是否正确！</div>
        <div class="address-message">
          <div>${this.checkAddress.name} ${this.checkAddress.phone}</div>  
          <div>${this.getAddress}</div>  
          <div>${this.checkAddress.address}</div>  
        </div>
        `,
        "确认收货信息",
        {
          dangerouslyUseHTMLString: true,
          cancelButtonText: "修改地址",
          confirmButtonText: "确认无误"
        }
      ).then(() => {
        this.submitOrder();
      });
    },
    submitOrder() {
      this.submitBtnStatus = true;
      this.$reqGet("api/store/is_pending_order")
        .then(res => {
          this.submitBtnStatus = false;
          if (res.data.data.status) {
            this.$confirm(
              "当前有待付款订单，您可以前往订单列表查看待付款订单，也可取消付款订单后，重新提交订单",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "查看订单列表",
                cancelButtonText: "取消待付款订单",
                type: "warning"
              }
            )
              .then(() => {
                this.$router.push({
                  name: "order-list"
                });
              })
              .catch(action => {
                if (action === "cancel") {
                  this.$reqGet("api/store/cancel_pending_order").then(res => {
                    if (res.data.success) {
                      this.$message({
                        type: "success",
                        message: "已取消!"
                      });
                      this.getOrderInfo(this.checkAddress.id);
                    }
                  });
                }
              });
          } else {
            let userData = {
              address_id: this.checkAddress.id,
              comment: this.comment,
              coupon_id: this.couponId
            };
            let expectedTime = "";
            if (this.hasBsk) {
              expectedTime =
                this.deleverDate + " " + this.deleverTime.split("-")[0];
            }
            userData.expected_time = expectedTime;
            if (this.isMerge) {
              Object.assign(
                this.jd_promise_calendar.product_ids,
                this.jd_promise_calendar.nomerge_product_ids
              );
            }
            userData.jd_promise_calendar = {
              product_ids: this.jd_promise_calendar.product_ids,
              promise_date: this.jd_promise_calendar.promise_date,
              promise_time_range: this.jd_promise_calendar.promise_time_range,
              promise_time_range_code: this.jd_promise_calendar
                .promise_time_range_code,
              reserving_date: this.jd_promise_calendar.reserving_date,
              reserving_date_code: this.jd_promise_calendar.reserving_date_code
            };
            this.$reqPost("api/store/checkout", userData, {
              noStringify: true,
              noAlertMessage: true
            }).then(res => {
              if (res.data.success) {
                this.userOrderInfo = res.data.data;
                this.isCheckOut = true;
                this.$router.push({
                  name: "submit-order",
                  params: { order_id: this.userOrderInfo.id }
                });
              }
            });
          }
        })
        .catch(() => {
          this.submitBtnStatus = false;
        });
    },
    delGoods() {
      this.$confirm("确认一键删除异常商品?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.getNoStockProducts();
        let product_ids = this.product_ids.join(",");
        this.$reqPost("api/store/cart/delNoStock", {
          product_ids: product_ids
        }).then(() => {
          this.product_ids = [];
          this.getOrderInfo(this.checkAddress.id);
        });
      });
    },
    getNoStockProducts() {
      this.product_ids = [];
      this.orderInfo = this.allProductsData.filter(item => {
        return item.items.length > 0;
      });
      let orderInfoLength = this.orderInfo.length;
      for (let i = 0; i < orderInfoLength; i++) {
        for (let j = 0; j < this.orderInfo[i].items.length; j++) {
          if (
            this.orderInfo[i].items[j].stock == 0 ||
            !this.orderInfo[i].items[j].can_buy_status
          ) {
            this.product_ids.push(this.orderInfo[i].items[j].product_id);
          }
        }
      }
    },
    checkAddressHasStock(address) {
      let town_name = address.town_id ? address.town.name : "";
      var label =
        address["zone"]["name"] +
        " " +
        address["city"]["name"] +
        " " +
        address["area"]["name"] +
        " " +
        town_name;
      var addrValue =
        address["zone_id"] +
        "_" +
        address["city_id"] +
        "_" +
        address["area_id"] +
        "_" +
        address["town_id"];
      sessionStorage.setItem(
        "sbzRegion",
        JSON.stringify({
          value: addrValue,
          label: label
        })
      );
      if (this.checkAddress.id) {
        this.getOrderInfo(this.checkAddress.id);
      }
    },
    open(mes) {
      this.$alert(mes, "", {
        confirmButtonText: "确定"
      });
    },
    open2(mes) {
      this.$message({
        message: mes,
        type: "success"
      });
    },
    setFormat(special) {
      return Math.round(special * 100) / 100;
    },
    // 点击修改送达时间
    editTime(time, calendarType) {
      this.currentTimeList = time;
      this.showEditDateModel = true;
      this.currentCalendarType = calendarType;
      if (calendarType == "calendar") {
        time.forEach((item, index) => {
          if (item.date == this.jd_promise_calendar.promise_date) {
            this.currentTimeDate = time[index];
            time[index].time_list.forEach((item2, index2) => {
              if (
                item2.time_range == this.jd_promise_calendar.promise_time_range
              ) {
                this.currentTimePointDate = time[index].time_list[index2];
              }
            });
          }
        });
      } else if (calendarType == "la_calendar") {
        time.forEach((item, index) => {
          if (item.date == this.jd_promise_calendar.reserving_date) {
            this.currentTimeDate = time[index];
          }
        });
      }
    },
    // 确定选择关闭时间模态框
    confirmEditDate() {
      if (this.currentCalendarType == "calendar") {
        this.jd_promise_calendar.promise_date = this.currentTimeDate.date;
        this.jd_promise_calendar.promise_week = this.currentTimeDate.week;
        this.jd_promise_calendar.promise_time_range = this.currentTimePointDate.time_range;
        this.jd_promise_calendar.promise_time_range_code = this.currentTimePointDate.time_range_code;
      } else if (this.currentCalendarType == "la_calendar") {
        this.jd_promise_calendar.reserving_date = this.currentTimeDate.date;
        this.jd_promise_calendar.reserving_week = this.currentTimeDate.week;
        this.jd_promise_calendar.reserving_date_code = this.currentTimeDate.reserving_date;
      }
    },
    validAddress() {
      if (
        !this.checkAddress.zone ||
        !this.checkAddress.city ||
        !this.checkAddress.area ||
        (this.checkAddress.town_id !== 0 && !this.checkAddress.town)
      ) {
        this.checkAddress.valid = 0;
        this.checkAddress.zone = this.checkAddress.zone || {};
        this.checkAddress.city = this.checkAddress.city || {};
        this.checkAddress.area = this.checkAddress.area || {};
        this.checkAddress.town = this.checkAddress.town || {};
      }
      this.checkAddress.town = this.checkAddress.town || {};
    },
    getDay(start_date) {
      const targetDate = new Date(start_date);
      const currentDate = new Date();
      const timeDiff = targetDate.getTime() - currentDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return daysDiff;
    },
    getCoupon() {
      this.coupon_show = true;
      let list = this.coupon.filter(item => item.selected);
      if (list.length > 0) {
        this.couponId = list[0].id;
      } else {
        this.couponId = -1;
      }
    },
    changeCoupon(coupon) {
      if (this.couponId === coupon.id) {
        this.couponId = -1;
      } else {
        this.couponId = coupon.id;
      }
    },
    checkoutCoupon() {
      this.coupon_show = false;
      this.getOrderInfo(this.checkAddress.id);
    },
    closeCoupon() {
      this.coupon_show = false;
      this.couponId = -1;
      this.getOrderInfo(this.checkAddress.id);
    }
  }
};
</script>

<style lang="less" scoped>
.big_wrap {
  height: 100vh;
  overflow: hidden;
}
.check_order_wrap {
  .check_order {
    padding: 20px 15px;
    background-color: #fff;
    .title {
      border-bottom: 2px solid #ececec;
      h2 {
        width: 240px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        margin: 0;
        padding-left: 5px;
        border-bottom: 2px solid #e2333f;
      }
    }
    h3 {
      font-size: 20px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 35px;
    }
    .pay_method_wrap {
      .pay_method {
        display: flex;
        > div {
          width: 120px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          margin-right: 10px;
          border: 1px solid rgba(218, 218, 218, 1);
          cursor: pointer;
        }
      }
    }
    .order-list {
      h2 {
        font-size: 24px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      .el-row > div:last-child {
        text-align: right;
        a {
          margin-top: 10px;
        }
      }
      .product_type_wrap {
        margin-bottom: 20px;
      }
      .products_type_tit {
        color: #999;
        border-bottom: 2px solid #e2333f;
        font-size: 16px;
        margin-bottom: 22px;
        padding-bottom: 4px;
      }
      .product-table {
        width: 1110px;
        margin: 0 0 0 30px;
        background-color: #fafafa;
        border: none;
        thead {
          color: #999;
        }
        .goods-item {
          background: #fff;
          td {
            width: 150px;
            padding: 0 15px;
            border: 0.5px solid #eee;
            text-align: center;
          }
          .td-product {
            width: 600px;
            text-align: left;
            .product {
              display: flex;
              align-items: center;
              img {
                width: 60px;
                height: 60px;
                margin: 10px 10px 10px 0;
              }
              p {
                display: inline-block;
                position: relative;
                width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -o-text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                height: 40px;
                text-align: right;
              }
              .type {
                color: #999999;
                width: 300px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .sku {
                color: #999999;
              }
            }
            .groups {
              border: 1px solid #e4e4e4;
              background: #fbfbfb;
              margin-bottom: 5px;
              .group {
                display: flex;
                align-items: center;
                > img {
                  width: 60px;
                  height: 60px;
                  margin: 10px;
                }
                > .name {
                  width: 450px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -o-text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  height: 40px;
                }
                > .num {
                  width: 50px;
                  text-align: center;
                }
              }
            }
            .modeOfDistribution {
              position: relative;
              display: flex;
              font-size: 14px;
              line-height: 40px;
              &:before {
                content: "";
                position: absolute;
                left: -15px;
                top: 0;
                display: inline-block;
                width: 100%;
                padding-right: 30px;
                height: 2px;
                background: #eee;
              }
              .way {
                span:nth-child(1) {
                  color: #333333;
                  margin-right: 12px;
                }
                span:nth-child(2) {
                  color: #fd6c17;
                  margin-right: 24px;
                }
              }
              .time {
                span:nth-child(1) {
                  color: #333333;
                }
                span:nth-child(2) {
                  color: #666666;
                  margin-right: 12px;
                }
                span.editTime {
                  color: #1b6cab;
                  cursor: pointer;
                  margin-right: 10px;
                }
                i {
                  font-style: normal;
                  color: #fd6c17;
                }
              }
            }
          }
          .totalforcat {
            background-color: #fff;
            color: #fc0010;
            font-size: 18px;
          }
        }
      }
      .td-footer {
        height: 80px;
        background: #fffaee;
        color: #333;
        text-align: center;
        td {
          border: 0.5px solid #eee;
        }
        span {
          color: #999;
        }
        .change-time {
          width: 120px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          background: rgba(226, 51, 63, 1);
          border: 1px solid rgba(226, 51, 63, 1);
          border-radius: 15px;
          margin-left: 10px;
          color: #fff;
          span {
            color: #fff;
          }
        }
      }
    }
    .remark {
      margin-top: 20px;
      > div {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
      }
      p {
        background-color: #fffaee;
        padding: 19px 112px 19px 28px;
        textarea {
          width: 1000px;
          height: 66px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(221, 221, 221, 1);
        }
      }
    }
    .order-footer-info {
      margin-top: 30px;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      padding: 30px 0;
      text-align: right;
      line-height: 40px;
    }
  }
  .real_pay_wrap {
    border-top: 1px solid #e0e0e0;
    text-align: right;
    font-size: 16px;
    color: #666;
    margin-bottom: 15px;
    margin-top: 30px;
    .a-button {
      cursor: pointer;
    }
    .red {
      color: #fc0010;
    }
    .red_word {
      font-size: 26px;
    }
    .el-button {
      width: 160px;
      height: 48px;
      line-height: 48px;
      color: #fff;
      padding: 0;
      font-size: 16px;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
      border-color: rgba(226, 51, 63, 1);
    }
  }
}
.red_word {
  font-weight: normal;
  color: #fc0010;
}
.mask_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: absolute;
    width: 700px;
    // height: 500px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    i {
      color: #bbb;
    }
  }
  .mask_info {
    margin: 20px 80px;
    border: 1px solid #bfbfbf;
    box-sizing: border-box;
    .date-list {
      text-align: center;
      li {
        height: 30px;
        line-height: 30px;
        background-color: #f2f2f2;
        cursor: pointer;
        &.actived {
          background-color: #fff;
        }
      }
    }
    .time-list {
      li {
        height: 50px;
        line-height: 50px;
        width: 260px;
        text-align: center;
        border: 1px solid #c8c8c8;
        margin: 10px 25px;
        cursor: pointer;
        &.actived {
          border-color: #dc3d27;
          background: rgba(252, 244, 243, 1);
        }
      }
    }
  }
  .mask_button {
    padding: 30px 150px;
    padding-top: 0;
    text-align: center;
    .el-button {
      display: inline-block;
      width: 146px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      font-size: 16px;
      color: #fff;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
      border-color: rgba(226, 51, 63, 1);
    }
    > div:last-child button {
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      color: #333;
    }
  }
}
.editDeliveryTimeBox {
  /deep/ .el-dialog {
    width: 650px;
  }
  /deep/ .el-dialog__header {
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 32px;
    background: #fbfbfb;
    .el-dialog__headerbtn {
      top: 7px;
    }
  }
  /deep/ .el-dialog__footer .dialog-footer {
    display: flex;
    justify-content: center;
    .el-button {
      font-size: 14px;
      width: 88px;
      height: 36px;
      &:nth-child(1) {
        color: #ffffff;
        background: #e4393d;
        border: 1px solid #e4393d;
      }
      &:nth-child(2) {
        color: #222222;

        background: #fbfbfb;
        border: 1px solid #f5f5f5;
      }
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 12px;
  }
  .way {
    font-size: 14px;
    font-weight: 600;
    color: #fd6c17;
    margin-top: 12px;
    margin-bottom: 8px;
  }
  .tips {
    font-size: 12px;
    color: #e64a3e;
    margin-top: 6px;
  }
  .timeBox {
    border: 1px solid #f5f5f5;
    height: 200px;
    background-color: #ffffff;
    width: 624px;
    .gridBox {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      border-left: 1px solid #f5f5f5;
      border-top: 1px solid #f5f5f5;
      li {
        background-color: rgba(255, 255, 255, 0.8);
        border-right: 1px solid #f5f5f5;
        border-bottom: 1px solid #f5f5f5;
        font-size: 12px;
        text-align: center;
        height: 54px;
        line-height: 25px;
        .weekend {
          color: #ffaf0f;
        }
        &.active {
          background: #e4393d;
          color: #ffffff;
          .weekend {
            color: #ffaf0f;
          }
        }
      }
    }
    .calendarDateBox {
      display: flex;
      text-align: center;
      flex-wrap: wrap;
      background-color: #fbfbfb;
      justify-content: space-around;
      li {
        cursor: pointer;
        height: 54px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        &.active {
          background-color: #ffffff;
          color: #e2333f;
        }
      }
    }
    .calendarTimeBox {
      display: flex;
      li {
        cursor: pointer;
        width: 120px;
        height: 35px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        font-size: 12px;
        color: #666666;
        line-height: 35px;
        text-align: center;
        margin-left: 12px;
        margin-top: 12px;
        &.active {
          color: #e2333f;
        }
      }
    }
  }
}
.coupon-dialog {
  /deep/ .el-dialog__header {
    padding-bottom: 0;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    > button {
      width: 130px;
    }
    .coupon-confirm {
      background: #e2333f;
      border: none;
    }
  }
}
.remove-btn {
  background-color: #dc3d27;
  color: #ffffff;
}
.remove-goods {
  background-color: #dc3d27;
  color: #ffffff !important;
  width: 132px !important;
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 40px !important;
  font-size: 14px !important;
}
.btn-disabled {
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #efefef !important;
  border-color: #ddd !important;
}
/deep/ .el-tabs__item.is-active {
  color: #e4393d;
}
/deep/ .el-tabs__active-bar {
  background-color: #e4393d;
}
.coupon-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .coupon-item {
    margin: 0 10px 20px;
    width: 45%;
    position: relative;
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    .coupon {
      height: 100px;
      display: flex;
      position: relative;
      .money {
        width: 90px;
        height: 100%;
        background: linear-gradient(to left top, #fcda9a, #fdf1d6);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .price {
          color: #e2333f;
          font-weight: bold;
          .price-unit {
            font-size: 16px;
          }
          .price-coupon {
            font-size: 32px;
            line-height: 28px;
          }
        }
        .text {
          font-size: 12px;
          color: #666666;
        }
      }
      .coupon-detail {
        margin-left: 12px;
        padding-top: 12px;
        flex: 1;
        font-size: 12px;
        color: #999;
        overflow: hidden;
        .title {
          font-size: 15px;
          color: #000;
          font-weight: bold;
        }
        .cell {
          width: 100%;
          margin-top: 2px;
          line-height: 16.5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .date {
          color: #e2333f;
          margin-top: 4px;
        }
      }

      .coupon-right {
        position: relative;
        width: 80px;
        text-align: center;
        .el-checkbox {
          margin-top: 30px;
        }
        .info {
          color: #999;
          font-size: 12px;
          position: absolute;
          bottom: 12px;
          .el-icon-arrow-right {
            font-size: 12px;
            transform: rotate(90deg);
          }
          .delete {
            transform: rotate(-90deg);
          }
        }
      }
    }

    .coupon-info {
      color: #999;
      font-size: 10px;
      padding: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/check-order.vue